import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  IAuthStore,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  IEventStore,
} from '../../mobx-store/storeInterfaces/eventsInterface';

interface IProps extends WithSnackbarProps {
  eventStore: IEventStore;
  authStore: IAuthStore;
  history: any;
}

@inject('eventStore')
@inject('authStore')
@observer
class event extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title = 'calender Seprator Management';

  constructor(props: IProps) {
    super(props);
  }

  handleTableButtonCellClicked = (index: number) => {
    const {
      history, eventStore,
    } = this.props;
    history.push(`/events/${eventStore.eventList[index].eventId}/edit`);
  };

  handleAdd = (): void => {
    this.props.history.push('/events/new');
  };

  getAddEventButton = () => ({
    title: 'Add',
    onAdd: this.handleAdd,
  });

  getEventTableHeader = () => [
    {
      title: 'Event Title',
    },
    {
      title: 'Image',
    },
    {
      title: 'Edit',
    },
  ];

  getEventTableData = () => this.props.eventStore.eventList
    .map((event) => ({
      ...event, edit: 'Edit',
    }));

  getEventTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Image',
      key: 'imageURL',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  componentDidMount() {
    const {
      authStore, eventStore,
    } = this.props;
    eventStore.getEvent(authStore.userData.countries);
  }

  render() {
    this.addButton = this.getAddEventButton();
    this.tableHeader = this.getEventTableHeader();
    this.tableData = this.getEventTableData();
    this.tableCellTypes = this.getEventTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage="There are no calender Seprator yet. Please add a new now"
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.eventStore.getEventsRequestStatus
          ]}
        />
      </div>
    );
  }
}

export default event;
